import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AlertService, AlertType } from 'src/app/shared/services/alert.service';
import { SelfTriageProtocolService } from 'src/app/shared/services/API/self-triage/self-triage-protocol.service';

@Component({
  selector: 'app-self-triage-protocol-delete-modal',
  templateUrl: './self-triage-protocol-delete-modal.component.html',
  styleUrls: ['./self-triage-protocol-delete-modal.component.css']
})
export class SelfTriageProtocolDeleteModalComponent implements OnInit {

  constructor(@Inject(MAT_DIALOG_DATA) public data: any, 
  public dialog: MatDialog, 
  public matDialogRef: MatDialogRef<SelfTriageProtocolDeleteModalComponent>,
  private protocolService: SelfTriageProtocolService,
  private alertService: AlertService) { }

  public isLoading:boolean;  

  ngOnInit(): void {
    this.isLoading = false;
  }
  
  close(){
    this.matDialogRef.close({deleteFlowchart: false}); 
  }
  
  clickDelete(){
    
    this.isLoading = true;

    this.protocolService.deleteProtocol(this.data.idProtocol).subscribe((response)=>{
      
      if(response.isError){
        this.alertService.show('Erro', response.errorDescription, AlertType.error);
        this.isLoading = false;
        return;
      }
      
      this.alertService.show('Sucesso', "Protocolo excluído com sucesso!", AlertType.success); 
      this.matDialogRef.close({deleteFlowchart: true}); 
    },
    (error)=>{
      console.log(error)
      this.isLoading = false;
      this.alertService.show('Erro inesperado', error, AlertType.error);
    });
  }
  
  clickCancel(){
    this.matDialogRef.close({deleteFlowchart: false}); 
  }
}
